import { SUPPORTED_FEATURES_BY_ROLE } from './features'

export const buildInitialFeaturesState = (role) => {
  const features = SUPPORTED_FEATURES_BY_ROLE[role]

  if (!features) {
    return []
  }

  return Object.entries(features).map(([key, value]) => ({
    label: value,
    id: key,
    checked: false,
    disabled: false
  }))
}

export const markUserFeatures = (features, userFeatures) => {
  return [...features].map((value) => {
    return {
      ...value,
      checked: userFeatures[value.id] ?? false
    }
  })
}

export const buildFeaturesPayload = (features) => {
  return features.reduce((payload, value) => {
    payload[value.id] = value.checked

    return payload
  }, {})
}

export const markFeaturesCheckbox = (checkboxes, idx, checked) => {
  const newCheckboxes = [...checkboxes]
  newCheckboxes[idx].checked = checked

  return newCheckboxes
}
